import { type ImageFileType, imageFileTypes } from 'BreetHelpers';

import type { IFileMimeType } from './helpers';

export const FileMimeType = ({ mimeType, ...rest }: IFileMimeType) => {
	const isImage = imageFileTypes.includes(mimeType as ImageFileType);

	const imageMimeTypeColor = '#7F56D9';
	const otherMimeTypeColor = '#D92D20';

	const color = isImage ? imageMimeTypeColor : otherMimeTypeColor;

	return (
		<MimeType
			{...rest}
			mimeType={mimeType}
			color={color}
		/>
	);
};

const MimeType = ({ mimeType, color, ...rest }: IFileMimeType) => (
	<svg
		width='40'
		height='40'
		viewBox='0 0 40 40'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		data-testid='file-mime-type'
		{...rest}
	>
		<path
			d='M4 4C4 1.79086 5.79086 0 8 0H24L36 12V36C36 38.2091 34.2091 40 32 40H8C5.79086 40 4 38.2091 4 36V4Z'
			fill={color}
		/>
		<path
			opacity='0.3'
			d='M24 0L36 12H28C25.7909 12 24 10.2091 24 8V0Z'
			fill='white'
		/>
		<text
			x='20'
			y='30'
			textAnchor='middle'
			fontSize='10'
			fontWeight='bold'
			fill='white'
			fontFamily='sans-serif'
		>
			{(mimeType ?? 'file').toUpperCase()}
		</text>
	</svg>
);
